<loading></loading>
@if (isUserVerified) {
<div>
  <router-outlet></router-outlet>
  <nps></nps>
  <app-shell></app-shell>
</div>
}

@if (!isUserVerified) {
<div>
  <router-outlet></router-outlet>
</div>
}